import Vue from 'vue'

import Router from 'vue-router'
//公共
// import 404 from '@/views/404.vue'

//首页
import Home from '@/views/home.vue'

//注册登录
import login from '@/views/login/login.vue'
import forget_pwd from '@/views/login/forget_pwd.vue'

//社区
import community from '@/views/community/community.vue'
import findDetail from '@/views/community/findDetail/findDetail.vue'
import communityHome from '@/views/community/communityHome.vue'

//圈子
import communityCircle from '@/views/community/communityCircle.vue'
import circleDetail from '@/views/community/circle/circleDetail.vue'
import addWork from '@/views/community/circle/addWork.vue'
import communityPhoto from '@/views/community/communityPhoto.vue'


//个人和他人主页
import Ucenter from '@/views/community/Ucenter.vue'
import Pcenter from '@/views/community/Pcenter.vue'
import Puploadfile from '@/views/community/Puploadfile.vue'
import PhotoShow from '@/views/community/PhotoShow.vue'

//活动
import activity_index from '@/views/activity/activity_index.vue'//活动首页
import activity_details from '@/views/activity/activity_details.vue'//活动详情

import workDeatils_type1 from '@/views/activity/workDeatils_type1.vue'//作品详情 组图
import workDeatils_type2 from '@/views/activity/workDeatils_type2.vue'//作品详情 单图


import user_follow from '@/views/community/user_follow.vue'//用户自己关注
import works_list from '@/views/good_works/works_list.vue'//优秀作品列表
// import details from '@/views/good_works/details.vue'//优秀作品详情

Vue.use(Router)
// 解决重复路由报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

let routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  // 活动首页
  {
    path: '/activity_index',
    name: 'activity_index',
    component: activity_index,

    meta: {
      title: '活动首页'
    }
  },

  // 活动详情页
  {
    path: '/activity_details/:id',
    name: 'activity_details',
    component: activity_details,

    meta: {
      // title: '活动详情页'
    }

  },

  // 作品详情
  {
    path: '/workDeatils_type1',
    name: 'workDeatils_type1',
    component: workDeatils_type1,
    meta: {
      // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  {
    path: '/workDeatils_type2',
    name: 'workDeatils_type2',
    component: workDeatils_type2
  },

  // 登录注册
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录注册',
      // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  // 忘记密码
  {
    path: '/forget_pwd',
    name: 'forget_pwd',
    component: forget_pwd,
    meta: {
      title: '忘记密码',
      // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  {
    path: '/PhotoShow',
    name: 'PhotoShow',
    component: PhotoShow
  },

  //社区
  {
    path: '/community',
    name: 'community',
    component: community,
    meta: {
      hideHead: true,
      hideFoot: true,
    },
    children: [
      {
        path: '/',
        name: 'communityHome',
        component: communityHome,
        meta: {
          title: '社区发现',
        }
      },
      {
        path: '/findDetail/:id',
        name: 'findDetail',
        component: findDetail
      },

      {
        path: '/communityCircle',
        name: 'communityCircle',
        component: communityCircle,
        meta: {
          title: '社区圈子',
        }
      },
      {
        path: '/communityPhoto',
        name: 'communityPhoto',
        component: communityPhoto,
        meta: {
          title: '影展',
        }
      },
      {
        path: '/circleDetail/:id',
        name: 'circleDetail',
        component: circleDetail
      },
      {
        path: '/addWork/:id',
        name: 'addWork',
        component: addWork,
        meta: {
          title: '发布作品',
          // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },
      // 别人主页
      {
        path: '/Ucenter/:id',
        name: 'Ucenter',
        component: Ucenter,
        meta: {
          // title: '别人主页',
          // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },
      // 自己主页
      {
        path: '/Pcenter',
        name: 'Pcenter',
        component: Pcenter,
        meta: {
          // title: '自己主页',
          // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },
      {
        path: '/Puploadfile',
        name: 'Puploadfile',
        component: Puploadfile,

        meta: {
          // title:''
          // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },

      // 用户自己关注
      {
        path: '/user_follow',
        name: 'user_follow',
        component: user_follow,
        // meta: {
        //   requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        // },
      },

    ]

  },
  // 优秀作品
  {
    path: '/works_list',
    name: 'works_list',
    component: works_list,
    meta: {
      title: '优秀作品',
      // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  //优秀作品 详情
  // {
  //   path: '/details/:id',
  //   name: 'details',
  //   component: details

  // },
];

const router = new Router({
  mode: 'hash',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});


const requireContext = require.context(
  './',
  true,
  /\.js$/
)
requireContext.keys().forEach(filename => {
  if (filename === './index.js') return
  const routerModule = requireContext(filename)
  routes = [...routes, ...(routerModule.default || routerModule)]
})



router.beforeEach((to, from, next) => {
  let fullPath = from.fullPath//上个页面的路径
  let redirectUrl = from.fullPath;;//是否登陆
  // console.log(to.query);
  if (to.path == '/login?state=1') {
    //如果是登录页面  就不拦截
    return next()//直接跳转
  }
  //判断路由的meta的requireAuth是否为true,如果没有直接进入
  if (to.meta.requireAuth) {
    // 需要登录  判断是否登陆
    // console.log(localStorage.getItem('id'));
    if (localStorage.getItem('id')) {
      next()//如果登录  直接跳转
    } else {
      //如果没有 直接进入
      next({
        path: '/login?state=1',
        query: {
          redirect: to.fullPath //记录当前是从哪里跳过去的   在登录后直接返回原来的页面
        }
      })
    }
  } else {
    // 不用登录
    next()//直接跳转
  }
})


export default router




// WEBPACK FOOTER //
// ./src/router/index.js